/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AwsServiceCdnPresignResponse } from "./AwsServiceCdnPresignResponse";

export type AwsServiceCdnPresignResponseApiRespoonse = {
  data?: AwsServiceCdnPresignResponse;
  status?: AwsServiceCdnPresignResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AwsServiceCdnPresignResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
